import SENSITIVE_FIELD_NAMES from 'settings/sensitive-field-names';

const URL_PARAMETERS = {
	accessCode: SENSITIVE_FIELD_NAMES.accessCode,
	country: 'country',
	countryId: 'countryid', // soon to be deprecated (replaced by country)
	currency: 'currency',
	customAttributes: 'customAttributes', // Optional parameters send by partners that need to be returned to webshop
	disableOfferingOptions: 'disableOptions', // Optional parameter sent by partners to disable the offering options selection/change
	editColors: 'edit-colors',
	email: SENSITIVE_FIELD_NAMES.email,
	externalOfferingId: 'eoid',
	language: 'language',
	locale: 'locale', // soon to be deprecated (replaced by language)
	priceMultiplier: 'pr_mu',
	shopId: 'shopid', // shop id is set by SmartLink when used API key belongs to a record in the shop table
	sizeSelect: 'sizeselect',
	skuQuantity: 'sku_q', // Optional parameter sent by partners to prefill the quantity of the SKU
	userToken: SENSITIVE_FIELD_NAMES.userToken,
	voucherCode: 'vc',
	/**
	 * Optional parameter sent by partners to limit the available print color options when opening the creator from a smartlink.
	 * Possible values are:
	 * - A number: Limits the maximum print colors options to the specified number.
	 * - 'fc': Limits the available print color options to full color.
	 */
	printColors: 'fe_pc',
	/**
	 * Optional parameter sent by partners to limit the available print position options when opening the creator from a smartlink.
	 * Possible values are:
	 * - An array of strings: Limits the available print position options to the specified positions.
	 * - A string: Limits the available print position options to the specified position.
	 */
	printPositions: 'fe_pp',
};

export default URL_PARAMETERS;
